import { Component, Input, OnInit } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { TimeOffApprovalFlow } from '@models/time-off-v3/time-off-approval-flow.model';
import { TimeOffApprovalObserverType } from '@models/time-off-v3/time-off-approval-observer-type.model';
import { TimeOffApprovalObserver } from '@models/time-off-v3/time-off-approval-observer.model';
import { MatSelectChange } from '@angular/material/select';
import { ApprovalObserverTypeDisplayOptions } from '@app/types/translatables/time-off-v3-display.options';

@Component({
    selector: 'app-approval-observers-form',
    templateUrl: './approval-observers.template.html',
    styleUrls: ['./approval-observers.style.scss'],
})
export class ApprovalObserversForm extends BaseForm implements OnInit {
    @Input() approvalFlow: TimeOffApprovalFlow;
    isLoading = false;
    observerTypes: TimeOffApprovalObserverType[] = [];
    initialApprovalObservers: TimeOffApprovalObserver[] = [];
    addedApprovalObservers: TimeOffApprovalObserver[] = [];
    deletedApprovalObservers: TimeOffApprovalObserver[] = [];
    specificPersonObserverTypeId: number;

    approvalObserverTypeDisplay = ApprovalObserverTypeDisplayOptions;

    get approvalObservers(): TimeOffApprovalObserver[] {
        return [...this.initialApprovalObservers, ...this.addedApprovalObservers];
    }

    async ngOnInit(): Promise<void> {
        this.isLoading = true;

        const [observerTypes] = await TimeOffApprovalObserverType.get();
        const [approvalObservers] = await TimeOffApprovalObserver.with('observer')
            .where('timeOffApprovalFlowId', this.approvalFlow.id)
            .get();
        const [specificPersonObserverType] = observerTypes.filter((observerType: TimeOffApprovalObserverType) =>
            observerType.isSpecificPerson()
        );

        this.observerTypes = observerTypes;
        this.initialApprovalObservers = approvalObservers;
        this.specificPersonObserverTypeId = specificPersonObserverType.id;

        this.isLoading = false;
    }

    wipeSpecificPerson(event: MatSelectChange, approvalObserver: TimeOffApprovalObserver): void {
        if (event.value === this.specificPersonObserverTypeId) {
            return;
        }

        approvalObserver.observerId = null;
    }

    isObserverTypeUsed(observerTypeId: number): boolean {
        return (
            this.approvalObservers
                .map((approvalObserver: TimeOffApprovalObserver) => approvalObserver.timeOffApprovalObserverTypeId)
                .filter((id: number) => id !== this.specificPersonObserverTypeId)
                .findIndex((id: number) => id === observerTypeId) > -1
        );
    }

    addApprovalObserver(): void {
        const [firstAvailableObserverType] = this.observerTypes.filter(
            (observerType: TimeOffApprovalObserverType) => !this.isObserverTypeUsed(observerType.id)
        );

        this.addedApprovalObservers.push(
            new TimeOffApprovalObserver({
                timeOffApprovalObserverTypeId: firstAvailableObserverType.id,
                timeOffApprovalFlowId: this.approvalFlow.id,
            })
        );
    }

    removeApprovalObserver(approvalObserver: TimeOffApprovalObserver): void {
        if (approvalObserver.id) {
            this.deletedApprovalObservers.push(approvalObserver);
            const removalIndex = this.initialApprovalObservers.findIndex(
                (_approvalObserver: TimeOffApprovalObserver) => _approvalObserver.id === approvalObserver.id
            );
            this.initialApprovalObservers.splice(removalIndex, 1);
            return;
        }

        const removalIndex = this.addedApprovalObservers.findIndex(
            (_approvalObserver: TimeOffApprovalObserver) => _approvalObserver === approvalObserver
        );
        this.addedApprovalObservers.splice(removalIndex, 1);
    }
}
